<!-- eslint-disable vue/no-v-html -->
<template>

  <div>
    <div class="list">
      <div
        v-for="(item,index) in list"
        :key="index"
        class="item"
      >
        <div
          v-for="subItem in item"
          :key="subItem.teamId"
          class="subItem"
        >
          {{ subItem.workTypeName }}:{{ subItem.personCount }}人
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
import OnEvent from '../common/OnEvent.vue'
import { workTypePersonCount } from '@/api/manage'
import { splitArr } from '@/utils/agreementUtil'
export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: String,
      required: true,
      default: ''
    },
    request: {
      type: Object,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    },
    linkage: {
      type: Object,
      default: () => {}
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canEdit: false,
      ctrlKey: 17,
      isCtrlDown: false,
      cancelRequest: null,
      list: []
    }
  },
  computed: {
    ...mapState({
      editMode: (state) => state.compose.editMode,
      curComponent: (state) => state.compose.curComponent,
      projectItem: (state) => state.user.projectItem
    })
  },
  created() {
    this.getData()
    // 注意，修改时接口属性时不会发数据，在预览时才会发
    // 如果要在修改接口属性的同时发请求，需要 watch 一下 request 的属性
    if (this.request) {
      // 第二个参数是要修改数据的父对象，第三个参数是修改数据的 key，第四个数据修改数据的类型
      this.cancelRequest = request(
        this.request,
        this.element,
        'propValue',
        'string'
      )
    }
  },
  beforeDestroy() {
    // 组件销毁时取消请求
    this.request && this.cancelRequest()
  },
  methods: {
    getData() {
      workTypePersonCount({
        projectId: this.projectItem.projectId
      }).then((res) => {
        this.list = splitArr(res.data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .item {
    display: flex;
    .subItem {
      flex: 1;
    }
  }
}
</style>
